import {Locale} from '../../../types';
import {ShippingDestinationCountryFlag} from '../../Icon/IconName';

export interface ShippingDestination {
  name: string;
  id: string;
  flag: ShippingDestinationCountryFlag;
}

export const getShippingDestinationList = (
  locale: Locale,
): ShippingDestination[] => [
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagAL,
    name: locale === Locale.es_ZZ ? 'Albania' : 'Albania',
    id: 'AL',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagDZ,
    name: locale === Locale.es_ZZ ? 'Algeria' : 'Algeria',
    id: 'DZ',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagAU,
    name: locale === Locale.es_ZZ ? 'Australia' : 'Australia',
    id: 'AU',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagAZ,
    name: locale === Locale.es_ZZ ? 'Azerbaiyán' : 'Azerbaijan',
    id: 'AZ',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagBH,
    name: locale === Locale.es_ZZ ? 'Bahrein' : 'Bahrain',
    id: 'BH',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagBD,
    name: locale === Locale.es_ZZ ? 'Bangladesh' : 'Bangladesh',
    id: 'BD',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagBB,
    name: locale === Locale.es_ZZ ? 'Barbados' : 'Barbados',
    id: 'BB',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagBA,
    name:
      locale === Locale.es_ZZ
        ? 'Bosnia y Herzegovina'
        : 'Bosnia and Herzegovina',
    id: 'BA',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagBR,
    name: locale === Locale.es_ZZ ? 'Brasil' : 'Brazil',
    id: 'BR',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagBF,
    name: locale === Locale.es_ZZ ? 'Burkina Faso' : 'Burkina Faso',
    id: 'BF',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagCV,
    name: locale === Locale.es_ZZ ? 'Cabo Verde' : 'Cabo Verde',
    id: 'CV',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagKH,
    name: locale === Locale.es_ZZ ? 'Camboya' : 'Cambodia',
    id: 'KH',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagCM,
    name: locale === Locale.es_ZZ ? 'Camerún' : 'Cameroon',
    id: 'CM',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagCA,
    name: locale === Locale.es_ZZ ? 'Canadá' : 'Canada',
    id: 'CA',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagCL,
    name: locale === Locale.es_ZZ ? 'Chile' : 'Chile',
    id: 'CL',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagKM,
    name: locale === Locale.es_ZZ ? 'Comoras' : 'Comoros',
    id: 'KM',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagCR,
    name: locale === Locale.es_ZZ ? 'Costa Rica' : 'Costa Rica',
    id: 'CR',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagCI,
    name: locale === Locale.es_ZZ ? 'Costa de Marfil' : "Côte d'Ivoire",
    id: 'CI',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagDO,
    name:
      locale === Locale.es_ZZ ? 'República Dominicana' : 'Dominican Republic',
    id: 'DO',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagSV,
    name: locale === Locale.es_ZZ ? 'El Salvador' : 'El Salvador',
    id: 'SV',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagET,
    name: locale === Locale.es_ZZ ? 'Etiopía' : 'Ethiopia',
    id: 'ET',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagGH,
    name: locale === Locale.es_ZZ ? 'Ghana' : 'Ghana',
    id: 'GH',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagGD,
    name: locale === Locale.es_ZZ ? 'Grenada' : 'Grenada',
    id: 'GD',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagGT,
    name: locale === Locale.es_ZZ ? 'Guatemala' : 'Guatemala',
    id: 'GT',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagHN,
    name: locale === Locale.es_ZZ ? 'Honduras' : 'Honduras',
    id: 'HN',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagIS,
    name: locale === Locale.es_ZZ ? 'Islandia' : 'Iceland',
    id: 'IS',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagIN,
    name: locale === Locale.es_ZZ ? 'India' : 'India',
    id: 'IN',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagJP,
    name: locale === Locale.es_ZZ ? 'Japón' : 'Japan',
    id: 'JP',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagJO,
    name: locale === Locale.es_ZZ ? 'Jordania' : 'Jordan',
    id: 'JO',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagKE,
    name: locale === Locale.es_ZZ ? 'Kenia' : 'Kenya',
    id: 'KE',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagXK,
    name: locale === Locale.es_ZZ ? 'Kosovo' : 'Kosovo',
    id: 'XK',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagKW,
    name: locale === Locale.es_ZZ ? 'Kuwait' : 'Kuwait',
    id: 'KW',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagLS,
    name: locale === Locale.es_ZZ ? 'Lesoto' : 'Lesotho',
    id: 'LS',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagMY,
    name: locale === Locale.es_ZZ ? 'Malaysia' : 'Malaysia',
    id: 'MY',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagMV,
    name: locale === Locale.es_ZZ ? 'Maldivas' : 'Maldives',
    id: 'MV',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagMU,
    name: locale === Locale.es_ZZ ? 'Mauricio' : 'Mauritius',
    id: 'MU',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagMX,
    name: locale === Locale.es_ZZ ? 'México' : 'Mexico',
    id: 'MX',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagMD,
    name:
      locale === Locale.es_ZZ
        ? 'Moldavia (República de)'
        : 'Moldova (Republic of)',
    id: 'MD',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagME,
    name: locale === Locale.es_ZZ ? 'Montenegro' : 'Montenegro',
    id: 'ME',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagMZ,
    name: locale === Locale.es_ZZ ? 'Mozambique' : 'Mozambique',
    id: 'MZ',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagNA,
    name: locale === Locale.es_ZZ ? 'Namibia' : 'Namibia',
    id: 'NA',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagNZ,
    name: locale === Locale.es_ZZ ? 'Nueva Zelanda' : 'New Zealand',
    id: 'NZ',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagNE,
    name: locale === Locale.es_ZZ ? 'Níger' : 'Niger',
    id: 'NE',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagPK,
    name: locale === Locale.es_ZZ ? 'Pakistán' : 'Pakistan',
    id: 'PK',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagPA,
    name: locale === Locale.es_ZZ ? 'Panamá' : 'Panama',
    id: 'PA',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagPE,
    name: locale === Locale.es_ZZ ? 'Perú' : 'Peru',
    id: 'PE',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagPH,
    name: locale === Locale.es_ZZ ? 'Filipinas' : 'Philippines',
    id: 'PH',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagRW,
    name: locale === Locale.es_ZZ ? 'Ruanda' : 'Rwanda',
    id: 'RW',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagKN,
    name:
      locale === Locale.es_ZZ
        ? 'San Cristóbal y Nieves'
        : 'Saint Kitts and Nevis',
    id: 'KN',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagSN,
    name: locale === Locale.es_ZZ ? 'Senegal' : 'Senegal',
    id: 'SN',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagRS,
    name: locale === Locale.es_ZZ ? 'Serbia' : 'Serbia',
    id: 'RS',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagSL,
    name: locale === Locale.es_ZZ ? 'Sierra Leone' : 'Sierra Leone',
    id: 'SL',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagSG,
    name: locale === Locale.es_ZZ ? 'Singapur' : 'Singapore',
    id: 'SG',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagZA,
    name: locale === Locale.es_ZZ ? 'Sudáfrica' : 'South Africa',
    id: 'ZA',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagLK,
    name: locale === Locale.es_ZZ ? 'Sri Lanka' : 'Sri Lanka',
    id: 'LK',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagTW,
    name:
      locale === Locale.es_ZZ
        ? 'Taiwán, provincia de China'
        : 'Taiwan, Province of China',
    id: 'TW',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagTH,
    name: locale === Locale.es_ZZ ? 'Tailandia' : 'Thailand',
    id: 'TH',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagTG,
    name: locale === Locale.es_ZZ ? 'Togo' : 'Togo',
    id: 'TG',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagTR,
    name: locale === Locale.es_ZZ ? 'Turquía' : 'Turkey',
    id: 'TR',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagAE,
    name: locale === Locale.es_ZZ ? 'Emiratos Árabes Unidos' : 'UAE',
    id: 'AE',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagUS,
    name:
      locale === Locale.es_ZZ
        ? 'Estados Unidos de América'
        : 'United States of America',
    id: 'US',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagUY,
    name: locale === Locale.es_ZZ ? 'Uruguay' : 'Uruguay',
    id: 'UY',
  },
  {
    flag: ShippingDestinationCountryFlag.IcShippingFlagVN,
    name: locale === Locale.es_ZZ ? 'Vietnam' : 'Viet Nam',
    id: 'VN',
  },
];
